// extracted by mini-css-extract-plugin
export default {"campaignStatsSubheader":"RPbIalom745KFIipPk9i","campaignStatsSubheaderRecipients":"ndSH9GmLfkrXKnD1rnMc","campaignStatsSubheaderSubject":"m9qSX9E_TrYonhk9Tihi"};